
// This file now serves as a redirect to the Home component for backward compatibility
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Index = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to the Home component
    navigate('/');
  }, [navigate]);
  
  return null;
};

export default Index;
